const horizonText = (gsap, mm) => {
  
  const $horizons = $('.horizon-text');
  
  if ($horizons.length) {
    
    mm.add("(max-width: 991px)", () => {
      $horizons.each(function (index) {

        const w = $(this)[0];
        const section = $(this).parent()[0];
        const [x, xEnd] = ['100%', (w.scrollWidth - section.offsetWidth) * -1.85];

        gsap.fromTo(w, {  x  }, {
          x: xEnd,
          ease: 'none',
          scrollTrigger: { 
            trigger: section, 
            scrub: 0.5,
            start: 'top 100%',
            end: 'bottom top'
          }
        });

      });
    });

    mm.add("(min-width: 992px)", () => {
      $horizons.each(function (index) {

        const w = $(this)[0];
        const section = $(this).parent()[0];
        const [x, xEnd] = ['100%', (w.scrollWidth - section.offsetWidth) * -2.5];

        gsap.fromTo(w, {  x  }, {
          x: xEnd,
          ease: 'none',
          scrollTrigger: { 
            trigger: section, 
            scrub: 0.5,
            start: 'top 100%',
            end: 'bottom top'
          }
        });

      });
    });
    
  }
  
}

export {
  horizonText
};
